(function () {
  'use strict';

  angular.module('app.studentImpactReport')
    .config([
      '$stateProvider',
      'RouteHelpersProvider',
      state
    ]);

  function state(
    $stateProvider,
    helper
  ) {
    $stateProvider
      .state('app.studentimpactreport', {
        url: '/student-impact-report',
        title: 'Student Impact Report',
        templateUrl: helper.basepath('studentImpactReport/studentImpactReport.html'),
        controller: 'StudentImpactReportController',
        controllerAs: 'vm',
        params: {
          parameter: null
        },
        resolve: helper.resolveFor(
          'datatables',
          'icons',
          'modernizr',
          'ngDialog',
          'ngWig',
          'ui.select'
        ),
        secured: true
      });
  }
})();
